import type { FC } from "react";

import { CustomButton, DefaultImage } from "@/components/atoms";
import { cn } from "@/lib/utils";
import { accountMock } from "@/modules/mocksData";
import { rootStore } from "@/store/RootStore";

interface ConnectedAccountProps {
  setConnection: () => void;
}

const ConnectedAccount: FC<ConnectedAccountProps> = ({ setConnection }) => {
  const isBrand = rootStore.authStore.isBrandAccess;

  return (
    <div
      className={cn(
        "w-[100%] flex items-center gap-[16px] border border-gray-200 text-gray-950 rounded-[6px] p-[16px]",
        isBrand && "w-[49%]"
      )}
    >
      {accountMock.image ? (
        <img
          src={accountMock.image}
          alt="Account"
          className="w-full h-full rounded-4xl"
        />
      ) : (
        <DefaultImage classes="w-[60px] h-[60px]  rounded-4xl" />
      )}

      <div className="mr-auto">
        <p className="mb-1 font-extrabold">{accountMock.name}</p>
        <p className="mb-4 text-sm">{accountMock.link}</p>
        <p className="text-sm">Account type: {accountMock.accountType}</p>
      </div>
      <CustomButton
        className="p-0"
        variant="link"
        type="button"
        onClick={setConnection}
        data-testid="connected-account-disconnect"
      >
        Disconnect account
      </CustomButton>
    </div>
  );
};

export default ConnectedAccount;
